import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

const variants = {
  default: 'bg-surface-muted text-muted-foreground border-border',
  primary: 'bg-primary/10 text-primary border-primary/20',
  success: 'bg-success-muted text-success-foreground border-success/20',
  warning: 'bg-warning-muted text-warning-foreground border-warning/20',
  danger: 'bg-danger-muted text-danger-foreground border-danger/20',
  // Deployment/exposure risk only (Resources, Pools, Connectors) — never
  // reuse success/danger for this; the two color families are deliberately
  // distinct from generic status meaning.
  public: 'bg-public-bg text-public-text border-public-text/20',
  private: 'bg-private-bg text-private-text border-private-text/20',
} as const

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof variants
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
      {...props}
    />
  )
}
